<template>
    <div class="cms-carousel" data-testid="cms-carousel" :class="{'swiper-ready': isReady}">
        <button class="swiper-button swiper-button-prev" data-testid="cms-carousel-prev">
            <VJoyIcon name="chevron-left" color="primary" size="small" />
        </button>
        <Swiper
            ref="swiper"
            :modules="[Navigation]"
            :navigation="{nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'}"
            :space-between="20"
            :breakpoints="breakpoints || defaultBreakpoints"
            @swiper="onReady"
        >
            <SwiperSlide v-for="(item, i) in items" :key="i">
                <slot name="slide" :item="item" />
            </SwiperSlide>
        </Swiper>
        <button class="swiper-button swiper-button-next" data-testid="cms-carousel-next">
            <VJoyIcon name="chevron-right" color="primary" size="small" />
        </button>
    </div>
</template>

<script setup lang="ts">
    import {onBeforeUnmount, ref} from 'vue';
    // @ts-expect-error No declaration file found for module 'swiper'.
    import type SwiperType from 'swiper';
    // @ts-expect-error No types for Navigation
    import {Navigation} from 'swiper';
    import {Swiper, SwiperSlide} from 'swiper/vue';
    import {VJoyIcon} from '@maltjoy/core-vue';
    import 'swiper/css';

    const defaultBreakpoints = {
        0: {slidesPerView: 1},
        480: {slidesPerView: 2},
        768: {slidesPerView: 3},
        992: {slidesPerView: 4},
    };

    defineProps<{items: any[]; breakpoints?: any}>();

    const isReady = ref(false);
    const swiperInstance = ref<SwiperType>();

    function onReady(swiper: SwiperType) {
        swiperInstance.value = swiper;
        isReady.value = true;
    }

    onBeforeUnmount(() => {
        const swiper = swiperInstance.value;
        if (!swiper || swiper.destroyed) {
            return;
        }
        if (swiper.el) {
            swiper.destroy(true, false);
            return;
        }
        swiper.destroyed = true;
    });
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .cms-carousel {
        position: relative;
        display: flex;
        -webkit-tap-highlight-color: transparent;
        transition: opacity var(--joy-transition-duration-default) var(--joy-transition-timing-function);
        opacity: 0;

        @include mq.screen_md {
            margin: 0 -24px;
        }

        .swiper {
            position: relative;
            flex-grow: 1;
        }

        .swiper-wrapper {
            align-items: stretch;
        }

        .swiper-button {
            flex: none;
            width: 24px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            transition: all var(--joy-transition-duration-default) var(--joy-transition-timing-function);
            background: var(--joy-color-background-default);

            &-disabled {
                opacity: 0;

                // pointer-events: none;
            }
        }

        &.swiper-ready {
            opacity: 1;
        }
    }
</style>
